export default [
  { value: 'INACTIVE', label: 'Inactive' },
  { value: 'ACTIVE', label: 'Active' },
  { value: 'ACTIVE-TURBO', label: 'Active, active with Turbo BPO' },
  { value: 'PENDING', label: 'Pending' },
];
